import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { TableCell } from "@mui/material";
import { Modal } from "src/Components";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import type { IUserPortfoGroupTableReport } from "src/Interfaces/portfolioGroups";
import BatchEditAssignmentModal from "./BatchEditAssignmentModal";
import EditAssignmentModal from "./EditAssignmentModal";

const AdditionalHeader: React.FC<IAdditionalHeaderProps> = ({
  selectedRowsIds,
  setSelectedRowsIds,
  onAction,
}) => {
  const [isBatchEditModalOpen, setIsBatchEditModalOpen] = React.useState(false);
  const hasSelection = !!selectedRowsIds.length;

  return (
    <TableCell>
      {isBatchEditModalOpen ? (
        <Modal
          UI={
            <BatchEditAssignmentModal
              selectedRowsIds={selectedRowsIds}
              setSelectedRowsIds={setSelectedRowsIds}
              onSuccess={onAction}
              onClose={() => setIsBatchEditModalOpen(false)}
            />
          }
          onClose={() => setIsBatchEditModalOpen(false)}
          modalBoxClassName="!min-w-[380px]"
        />
      ) : null}
      <div
        className="w-16 mx-auto"
        onClick={() => {
          if (hasSelection) setIsBatchEditModalOpen(true);
        }}
      >
        <EditIcon
          className={`cursor-pointer transition-all ${
            hasSelection ? "text-sky-700" : "text-gray-300"
          }`}
        />
      </div>
    </TableCell>
  );
};

const AdditionalCol: React.FC<{
  row: IUserPortfoGroupTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

  return (
    <TableCell>
      {isEditModalOpen ? (
        <Modal
          UI={
            <EditAssignmentModal
              row={row}
              onSuccess={onAction}
              onClose={() => setIsEditModalOpen(false)}
            />
          }
          onClose={() => setIsEditModalOpen(false)}
          modalBoxClassName="!min-w-[360px]"
        />
      ) : null}
      <div className="w-16 mx-auto" onClick={() => setIsEditModalOpen(true)}>
        <EditIcon className="text-sky-700 cursor-pointer" />
      </div>
    </TableCell>
  );
};

export const Additional: IAdditional<IUserPortfoGroupTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
